import { createGlobalState } from '@vueuse/core';
import { ref, computed } from 'vue';
import { useDisposes } from '@telecom/shared/composables/use-disposes';
import { EmbodimentHistoryService } from '../service/embodiment-history-service';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import type { EmbodimentHistoryState } from '../types';

export const useEmbodimentHistory = createGlobalState(() => {
    const embodimentHistoryService = injectService<EmbodimentHistoryService>(EmbodimentHistoryService);

    const { disposes } = useDisposes();

    const modelData = ref<EmbodimentHistoryState>(embodimentHistoryService.getModelData());
    disposes.push(embodimentHistoryService.onStateChange(state => modelData.value = state));

    const historyIndex = computed(() => modelData.value.historyIndex);

    const embodimentHistoryList = computed(() => modelData.value.history);

    function toggleNextEmbodimentHistory() {
        embodimentHistoryService.toggleNextHistory();
    }

    function togglePrevEmbodimentHistory() {
        embodimentHistoryService.togglePrevHistory();
    }

    return {
        historyIndex,
        embodimentHistoryList,
        toggleNextEmbodimentHistory,
        togglePrevEmbodimentHistory,
    };
});
